import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const SearchInputValue = ({ rule, onValueChange }) => (
  <div className='search-input-container'>
    <Input
      placeholder={rule.searchPlaceholder}
      value={rule.searchValue}
      onChange={(e, data) => onValueChange(rule.instanceId, 'searchValue', data.value)}
      fluid
    />
    {rule.allowAddCondition && (
      <button type='button' className='add-condition-link'>
        + Add condition
      </button>
    )}
  </div>
);

SearchInputValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

export default SearchInputValue;
